export default __webpack_public_path__ + "static/media/ic_shopping cart.c141e7d8.svg";